import { Component, computed, input, Input, signal, ViewChild } from '@angular/core'
import { ChartComponent, NgApexchartsModule } from 'ng-apexcharts'
import { ChartOptions } from 'src/app/shared/types/chart-options'
import { ModalConfig } from '../../modal/modal-config.interface'
import { StatGroupCounter } from 'src/app/shared/interfaces/statistics/stat-group-counter.interface'
import { CardComponent } from '../../card/card.component'

@Component({
    selector: 'sf-sparkline-pie-chart',
    imports: [NgApexchartsModule, CardComponent],
    templateUrl: './sparkline-pie-chart.component.html',
    styleUrls: ['./sparkline-pie-chart.component.scss'],
})
export class SparklinePieChartComponent {
    @ViewChild('chartspark') sparkChart!: ChartComponent
    @ViewChild('chart') chart!: ChartComponent

    @Input()
    chartTitle: string = ''

    // private _chartData: StatGroupCounter[] | null = null

    chartOptions = signal({
        series: [44, 55, 13, 43, 22],
        chart: {
            type: 'pie',
            height: 500,
            width: 500,
            sparkline: {
                enabled: false,
            },
        },
        title: {
            text: 'test',
            offsetX: 0,
            style: {
                fontSize: '16px',
            },
        },
        labels: ['Team A', 'Team B', 'Team C', 'Team D', 'Team E'],
    } as Partial<ChartOptions>)

    chartData = input<StatGroupCounter[] | null>(null)

    getChartData = computed(() => {
        const chartData = this.chartData()
        return {
            ...this.chartOptions(),
            series: chartData ? chartData.map((x) => x.count) : [],
            labels: chartData ? chartData.map((x) => x.group) : [],
        }
    })

    // @Input()
    // set chartData(value: StatGroupCounter[] | null) {
    //     this._chartData = value
    //     this.updateChartData()
    // }
    // get chartData(): StatGroupCounter[] | null {
    //     return this._chartData
    // }

    public sparkChartOptions: Partial<ChartOptions>

    constructor() {
        this.sparkChartOptions = {
            series: [44, 55, 13, 43, 22],
            chart: {
                height: 300,
                type: 'pie',
                sparkline: {
                    enabled: false,
                },
            },
            title: {
                text: 'test',
                offsetX: 0,
                style: {
                    fontSize: '16px',
                },
            },
            labels: ['Team A', 'Team B', 'Team C', 'Team D', 'Team E'],
        }

        // this.chartOptions = {
        //     series: [44, 55, 13, 43, 22],
        //     chart: {
        //         type: 'pie',
        //         height: 500,
        //         width: 500,
        //         sparkline: {
        //             enabled: false,
        //         },
        //     },
        //     title: {
        //         text: 'test',
        //         offsetX: 0,
        //         style: {
        //             fontSize: '16px',
        //         },
        //     },
        //     labels: ['Team A', 'Team B', 'Team C', 'Team D', 'Team E'],
        // }
    }

    // updateChartData(): void {
    //     if (this.chartData) {
    //         this.sparkChartOptions.series = this.chartData.map((x) => x.count)
    //         this.chartOptions.series = this.chartData.map((x) => x.count)
    //         this.sparkChartOptions.labels = this.chartData.map((x) => x.group)
    //         this.chartOptions.labels = this.chartData.map((x) => x.group)
    //         this.sparkChart.updateOptions(this.sparkChartOptions)
    //         this.chart.updateOptions(this.chartOptions)
    //     }
    // }
}
